export default "__VITE_ASSET__d86e9278__"